import * as React from "react";
const SvgCoworking = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6.75 5a.75.75 0 0 0-1.5 0v1.25c0 .414.336.75.75.75h1a.75.75 0 0 0 0-1.5h-.25V5Z"
      fill="currentColor"
    />
    <path
      d="M2 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="currentColor"
    />
    <path
      d="M2.75 11a.75.75 0 0 0-.75.75v9.5a.75.75 0 0 0 1.5 0V12.5h17v8.75a.75.75 0 0 0 1.5 0v-9.5a.75.75 0 0 0-.75-.75H21v-.25a.75.75 0 0 0-.75-.75V6.75A1.75 1.75 0 0 0 18.5 5H14a1.75 1.75 0 0 0-1.75 1.75V10a.75.75 0 0 0-.75.75V11H2.75Zm16-1h-5V6.75A.25.25 0 0 1 14 6.5h4.5a.25.25 0 0 1 .25.25V10Z"
      fill="currentColor"
    />
    <path
      d="M4.5 15.75c0-.966.784-1.75 1.75-1.75h3.5a1.75 1.75 0 1 1 0 3.5h-1v2.26l1.805.802a.75.75 0 0 1-.61 1.37l-1.944-.864-1.946.865a.75.75 0 1 1-.61-1.371l1.806-.802V17.5H6.25a1.75 1.75 0 0 1-1.75-1.75Zm5.25.25a.25.25 0 1 0 0-.5h-3.5a.25.25 0 1 0 0 .5h3.5ZM12.499 15.75c0-.966.784-1.75 1.75-1.75h3.5a1.75 1.75 0 1 1 0 3.5h-1v2.26l1.805.802a.75.75 0 1 1-.61 1.37L16 21.069l-1.946.865a.75.75 0 1 1-.61-1.371l1.806-.802V17.5h-1.001a1.75 1.75 0 0 1-1.75-1.75Zm5.25.25a.25.25 0 1 0 0-.5h-3.5a.25.25 0 0 0 0 .5h1.693a.739.739 0 0 1 .116 0h1.691Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCoworking;
